import { render, staticRenderFns } from "./Ferry.vue?vue&type=template&id=29d26dda&"
import script from "./Ferry.vue?vue&type=script&lang=js&"
export * from "./Ferry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports